import T from 'i18n-react'
import { createSelector } from 'reselect'
import * as R from 'ramda'
import P from 'helpers/predicates'

import { applyUnitsToProps } from 'helpers/specHelpers'

import { elementOrder, categoryOrder } from 'containers/Form/Project/constants'
import {
  entitySelector,
} from 'containers/Entity/selectors'
import {
  latestRevisionId,
  oldestRevisionId,
  originalRevisionId,
  modifiedRevisionId,
  revisions,
  latestRevision,
  oldestRevision,
  modifiedRevision,
  originalRevision,
  allRevisions,
} from 'containers/Project/Revision/selectors'
import {
  elementSelector
} from 'containers/Form/selectors'
import {
  formStatusSelector,
} from 'containers/Project/selectors'
import {
  MODULES,
} from './constants'

const allRevisionsSelector = createSelector(
  allRevisions,
  R.addIndex(R.map)((revision, index) => ({ value: parseInt(revision), label: `Revision ${index + 1}`}))
)

const groupData = (entity, modified, original) => {
  const groupedData = {}
  if (original && modified) {
    Object.entries(modified).forEach(([id, element]) => {
      const {
        values: modifiedValues,
        risks,
        units,
        key
      } = element

      const selectFromEntity = (type, idValue) => {
        const {id, ...sources} = entity[type][idValue]
        return sources
      }
      const riskSources = risks ? risks.map(riskValue => selectFromEntity(riskValue.type, riskValue.id)) : null
      const initValues = original[id] && original[id].values || []

      const item = {
        initValues,
        modifiedValues,
        risks: riskSources,
        units
      }
      groupedData[key] = item
    })
  }

  applyUnitsToProps(groupedData)
  return groupedData
}

const groupedDataSelector = createSelector(
  entitySelector,
  elementSelector,
  oldestRevision,
  groupData
)

const revisionDataSelector = createSelector(
  entitySelector,
  modifiedRevision,
  originalRevision,
  formStatusSelector,
  groupData
)

const specNavbarCategories = createSelector(
  groupedDataSelector,
  (groupedData) => {
    const filteredKeys = MODULES.filter((sectionKey) => {
      return groupedData[sectionKey] && 
             (groupedData[sectionKey].initValues.length ||
             groupedData[sectionKey].modifiedValues.length)
    })
    return filteredKeys.map((key) => {
      return {key: key, label: T.translate(`project.spec.${key}.label`)}
    })
  }
)

export {
  groupedDataSelector,
  allRevisionsSelector,
  revisionDataSelector,
  specNavbarCategories
}
